import axiosClient from './axiosClient';

const ridePromoCodeApi = {
  getPromoCodes: (params) => axiosClient.get('/rides/promo-codes', { params }),
  getPromoCode: (promoCodeId) => axiosClient.get(`/rides/promo-codes/${promoCodeId}`),
  createPromoCode: (payload) => axiosClient.post('/rides/promo-codes', payload),
  updatePromoCode: (promoCodeId, payload) => axiosClient.put(`/rides/promo-codes/${promoCodeId}`, payload),
  setPromoCodeStatus: (promoCodeId, status) => axiosClient.post(`/rides/promo-codes/${promoCodeId}/status`, { status }),
};

export default ridePromoCodeApi;
